module.exports = __webpack_public_path__ + "img/cover-jeu-04.5c10b91f.png";